var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"organization-in"},[_c('OrganizationForm',{attrs:{"btn-text":'Обновить'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }